if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.querySelector('span').innerText = 'Uploading Design ';
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData(this.form);
//       formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
//       formData.append('sections_url', window.location.pathname);
      
      
      //AJAX add to cart
    var shopifyAjaxAddURL = '/cart/add.js';
    var shopifyAjaxStorePageURL = '/search';
    evt.preventDefault();

    shopifyAjaxAddURL = this.form.getAttribute('action');
    //Disable add button
    if(typeof(upload_file) !== 'undefined'){
      console.log("Change ATC to Uploading...")
      var atc = submitButton.querySelector('span');
      atc.innerText = "Uploading Design";                                         
    }
    // Add to cart

    var formData = new FormData(this.form);
    if(typeof(upload_file) !== 'undefined'){
      formData.append('properties[Your Design]', upload_file, 'image.png');
    }
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    
      var params = {
        type: 'POST',
        contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
        processData: false, // NEEDED, DON'T OMIT THIS
        url: shopifyAjaxAddURL,
        data: formData,
        dataType: 'json',
        success: function(item) {
          submitButton.setAttribute('aria-disabled', false);;
          submitButton.querySelector('span').innerText = 'Added To Cart';
          submitButton.parentElement.querySelector('.cart-success').style.maxHeight = '50px'; 
          submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
		  
                    
          // Back to default button text
          setTimeout(function(){
            submitButton.querySelector('span').innerText = 'Add to Cart';
          }, 3000);

          // Added, show CTA
//           if($($btn).next('.added-cta').length == 0) {
//             var $cta = $('<a href="'+shopifyAjaxAddURL.replace('/add','')+'"></a>');
//             $cta.append($('<span class="beside-img">').html('See Cart'));
//             $cta.append(' ').append(theme.icons.chevronRight);
//             $cta = $cta.wrap('<div class="added-cta">').parent().hide().insertAfter($btn);
//             $('.shopify-payment-button').addClass('hidden');
//             $cta.slideDown(500, function(){
//               $(this).addClass('show');
//               // resize lightbox, if in quick-buy
//               if($btn.closest('#fancybox-content').length) {
//                 $.fancybox.resize();
//               }
//          	});
//           }
          
          if(totalPrice < 25){
            var cartValue = 5;
          }else if(totalPrice > 2000){
            var cartValue = 10;
          }else{
            var cartValue = 60;
          }
        // Log addtocart event for GTM
          window.dataLayer = window.dataLayer || [];                                            
          window.dataLayer.push({
            'page_type': 'product',
            'event': 'addtocart',
            'currency': Shopify.currency.active,
            'totalValue': cartValue,
            'productID': productID,
          });

          //       // Update header
//         $.get(shopifyAjaxStorePageURL, function(data){
//           var $newCartObj = $(data).find('.page-header .cartsummary');
//           var $currCart = $('.page-header .cartsummary');
//           $currCart.html($newCartObj.html());
//         })

        },
        error:  function(response) {
                      // Enable add button
                      submitButton.removeAttribute('disabled');

                      // Not added, show message
                      if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
                        var jsonRes = $.parseJSON(data.responseText);
                        theme.showQuickPopup(jsonRes.description, this.form.querySelector('button[type="submit"]:first'));
                      } else {
                        //Some unknown error? Disable ajax and add the old-fashioned way.
                        this.form.addClass('noAJAX');
                        // Log addtocart event for GTM
                        window.dataLayer = window.dataLayer || [];                                            
                        window.dataLayer.push({
                          'page_type': 'product',
                          'event': 'addtocart',
                          'currency': currentCurrency,
                          'totalValue': totalPrice,
                          'productID': productID,
                        });
                        $(this.form).submit();
                      }
        }
      };
    
    $.ajax(params);
      
      
//       config.body = formData;
      
      

//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);
//             return;
//           }

//           this.cartNotification.renderContents(response);
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           submitButton.classList.remove('loading');
//           submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
    }

    handleErrorMessage(errorMessage = false) {

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


